<template>
  <ul class="informe">
    <li class="informe--item" v-for="(item, index) in informes" :key="index">
      <ArticleMain
      :titleResume='item.titleResume'
      :title='item.title'
      :text='item.text'
      :linkPT='item.linkPT'
      :linkES='item.linkES'
      :linkIN='item.linkIN'
      :imgFull='item.imgFull'
      :imgLarge='item.imgLarge'
      :imgMedium='item.imgMedium'
      :imgSmall='item.imgSmall'/>
    </li>
  </ul>
</template>

<script>
import { apis } from '@/api.js'
import ArticleMain from '@/components/_ArticleMain'

export default {
  name: 'Informes3',
  components: {
    ArticleMain
  },
  data () {
    return {
      url: apis.api.informes3API,
      informes: ''
    }
  },
  methods: {
    getApi () {
      fetch(this.url)
        .then(response => response.json())
        .then(response => {
          this.informes = response
        })
    }
  },
  created () {
    this.getApi()
  }
}
</script>

<style>

</style>
